import gql from "graphql-tag";
import { toast } from "react-toastify";

import { sentryWrappedException } from "~/utils/Utils";
import getQuery from "../utils/get_query";
import ParcisionCookies from "../../../utils/Cookies";

type Filters = {
  active: boolean;
  played: boolean;
  bids: [number, number];
  prize: [number, number];
  dates: [Date, Date];
  contracts: string[];
  param1: string[];
  param2: string[];
  param3: string[];
  param4: string[];
  cparam0: string;
};

export default async function getContracts(pagenumber: number, sortby: string, filters: Filters) {
  try {
    const filters_ = {
      market: "finance_us",
      search: "",
      active: filters.active,
      played: filters.played,
      minBid: filters.bids[0],
      maxBid: filters.bids[1],
      minPrize: filters.prize[0],
      maxPrize: filters.prize[1],
      sDate: filters.dates[0].toISOString().split("T")[0],
      eDate: filters.dates[1].toISOString().split("T")[0],
      contracts: filters.contracts.length > 0 ? filters.contracts.join(",") : "",
      param1: filters.param1.length > 0 ? filters.param1.join(",") : "",
      param2: filters.param2.length > 0 ? filters.param2.join(",") : "",
      param3: filters.param3.length > 0 ? filters.param3.join(",") : "",
      param4: filters.param4.length > 0 ? filters.param4.join(",") : "",
      cparam0: "",
    };

    const address = ParcisionCookies.get("address");
    const variables = { pageNumber: pagenumber, sortBy: sortby, filters: filters_, address };

    const query = gql`
      query MyQuery($pageNumber: Float!, $sortBy: String!, $filters: Filters!, $address: String!) {
        getContracts(pageNumber: $pageNumber, sortBy: $sortBy, filters: $filters, address: $address) {
          nodes {
            cid
            cid_addr
            gparam
            cparam0
            num
            cparam1
            cparam2
            cparam3
            expire_snap
            payout
            image
            payout
            goptin
            gprize
            stage
            wager
            estimate1
            estimate2
            estimate3
            description_
            research
          }
          avaliable {
            contract {
              value
              count
            }
            symbol {
              value
              count
            }
            sector {
              value
              count
            }
            industry {
              value
              count
            }
            style {
              value
              count
            }
            mingoptin
            maxgoptin
            mingprize
            maxgprize
          }
        }
      }
    `;

    const data = await getQuery(query, variables);
    // @ts-expect-error
    return data.getContracts;
  } catch (error) {
    toast.error("Failed to collect contracts");
    sentryWrappedException(error);
    throw error;
  }
}
